var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mousedown":_vm.mouseDown}},[_c('header',{staticStyle:{"position":"relative"}},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"x",on:{"click":function($event){return _vm.$emit('exit','x')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }